import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducer';
import { useSelector } from 'react-redux';

const store = configureStore({
  reducer: rootReducer,
});

export type TRootState = ReturnType<typeof store.getState>;
export type TAppDispatch = typeof store.dispatch;

export default store;
